import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TBihinZaikoUkebaraiListGetReq,
  TBihinZaikoUkebaraiListInfoGetRes,
} from "./TBihinZaikoUkebarai"

/**
 * 在庫受払一覧に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class ZaikoBihinUkebaraiService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TBihinZaikoUkebaraiListGetReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TBihinZaikoUkebaraiListInfoGetRes[]>> =
        await this.getInner(`budget/bihinzaiko/ukebarailist`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
